import script from "./ArticleEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&setup=true&lang=js"

import "./ArticleEdit.vue?vue&type=style&index=0&id=2c6e9685&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6e9685"]])

export default __exports__